import { render, staticRenderFns } from "./toysLaptopView.vue?vue&type=template&id=3072b7bc&scoped=true&"
import script from "./toysLaptopView.vue?vue&type=script&lang=js&"
export * from "./toysLaptopView.vue?vue&type=script&lang=js&"
import style0 from "./toysLaptopView.vue?vue&type=style&index=0&id=3072b7bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3072b7bc",
  null
  
)

export default component.exports